<template>
   <!-- @menuClick="onMenuClick"
    :rightMenu="tabOptions" -->
  <DBox 
    :id="'cmp-licencing-licence_accounts-account_setup'" 
    :addButton="false"
   
  >
    <div class="ut-fc">
      <TextField2
        style="flex:1"
        v-if="isControlVisible(['costs','income','performance','thirdparty'])"
        id="distribution_fee_returns"
        :placeholder="$t('distribution_fee_returns')"
        :label="$t('distribution_fee_returns')"
        :value="selectedStatementDetails.statement.distribution_fee_returns"
        @blur="(e) => onTextFieldValueChange(e)"
        :lw="'165px'"
      />

      <TextField2
        style="flex:1"
        v-if="isControlVisible(['digital','costs','income','performance','thirdparty'])"
        id="return_handling_fee"
        :placeholder="$dft.capHead($t('return_handling_fee'))"
        :label="$dft.capHead($t('return_handling_fee'))"
        :value="selectedStatementDetails.statement.return_handling_fee"
        @blur="(e) => onTextFieldValueChange(e)"
        :lw="'165px'"
      />

      <Checkbox2
        style="flex:1"
        v-if="isControlVisible(['digital','costs','income','performance','thirdparty'])"
        :disabled="false"
        :id="'returns_have_leading_minus'"
        :label="$dft.capHead($t('returns_have_leading_minus'))"
        :value="selectedStatementDetails.statement.returns_have_leading_minus"
        :placeholder="$dft.capHead($t('returns_have_leading_minus'))"
        @input="onCheckboxChange"
        :lw="'165px'"
      />
      <TextField2
        style="flex:1"
        v-if="isControlVisible(['costs','income','performance','thirdparty'])"
        id="return_identifier"
        :placeholder="$dft.capHead($t('return_identifier'))"
        :label="$dft.capHead($t('return_identifier'))"
        :value="selectedStatementDetails.statement.return_identifier"
        @blur="(e) => onTextFieldValueChange(e)"
        :lw="'165px'"
        :bb="'none'"   
      />

    </div>
  </DBox>
</template>
<script>
import { createTV, tv } from "../../../../models/text-value.model";

export default {
  props: {
    selectedStatementDetails: {
      type: Object,
    },
  },

  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },
    };
  },
  computed: {
    tabOptions: function () {
      const options = [
        {
          text: this.$t("load_preset_btn"),
          value: "load_preset_btn",
        },
        {
          text: this.$t("btn_save_conf"),
          value: "btn_save_conf",
        },
      ];
      if (this.$store.getters.account.user.user_name == "details_helper") {
        return [
          { text: this.$t("new_preset_btn"), value: "new_preset_btn" },
          ...options,
        ];
      }

      return this.invoice_id == ""
        ? options
        : options.filter((x) => x.value == "new_preset_btn");
    },
    channel:function(){
      return this.selectedStatementDetails?.stmt?.digital_physical||'';
    }
  },
  methods: {
    onTextFieldValueChange: function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
      this.$emit("changed", payload);
    },
    onCheckboxChange: function ({ name, value }) {
      this.$emit("changed", {
        name,
        value: value ? "1" : "0",
      });
    },
    isControlVisible:function(channelName=[]){
        
        let flag= true;
        channelName.forEach(e=>{
          if(this.channel==e){
            flag = false;
          }
        });
      return flag;
    },
    onMenuClick:async function (payload) {
      this.$emit('tab_click',payload);
      // switch (payload) {
       
      //   case "load_preset_btn":{
      //     this.$emit('tab_click','load_preset_btn');
      //     break;
      //   }
      //   case "btn_save_conf":{
      //     this.$emit('tab_click','btn_save_conf');
      //     break;
      //   }
        
      }

  },
};
</script>
<style lang="scss">
.cmp--distribution-statement-sidewindow-import_setup {
  .flex-container {
    display: flex;
    padding: 10px;
    .flex-item {
      flex: 0.25;
      padding: 10px;
    }
  }
}
</style>
